import findDataObject from "../../../../objects/CommonUse/find_data_object";

export const buildTransactionObj = (basicTranInfo) => {
    let transactionObj = JSON.parse(JSON.stringify(findDataObject("investTransaction").investTransObj));
        transactionObj.investShortName = basicTranInfo.shortName;
        transactionObj.tranType = basicTranInfo.tranType;
        transactionObj.transNbr = basicTranInfo.transactionNbr.toString();
        transactionObj.quantity = basicTranInfo.quantity.toString();
        transactionObj.unitPrice = basicTranInfo.unitPrice.toString();
        transactionObj.transactionDate = basicTranInfo.currentGameDate;
        transactionObj.transactionGameMonth = basicTranInfo.monthNbr.toString();
    
    return transactionObj;
}

export default buildTransactionObj;